<script lang="ts">
    import * as echarts from 'echarts';
    import { _ } from 'svelte-i18n';

    import WidgetTemplateInner from '../../../../shared/Dashboard/WidgetTemplateInner.svelte';
    import {
        type DashboardComponentType,
        WidgetManager,
    } from '../../../../shared/Dashboard/WidgetManager';
    import { DataSchema, type DataType } from './types';

    export let dashboardItem: DashboardComponentType;
    export let widgetManager: WidgetManager;

    const colors = ['#ccc', '#91CC75', '#000'];
    export const defaultChartOption: echarts.EChartsOption = {
        color: colors,
        tooltip: {
            trigger: 'item',
        },
        grid: {
            containLabel: true,
            left: '0',
            right: '0',
            top: '4%',
            bottom: 0,
        },
        xAxis: [
            {
                type: 'category',
                // prettier-ignore
                data: ['przed 8:00', '8-9', '9-10', '10-11', '11-12', '12-13', '13-14', '14-15', '15-16', '16-17', '17-18', 'po 18:00'],
            },
        ],
        yAxis: [
            {
                type: 'value',
                name: $_('packages_stops'),
                position: 'left',
                alignTicks: true,
                minInterval: 1,
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: colors[2],
                    },
                },
                axisLabel: {
                    formatter: '{value}',
                },
            },
        ],
        series: [
            {
                name: 'Historia',
                type: 'bar',
                data: [1500, 5100, 7210, 8430, 8490, 9110, 9505, 9203, 7690, 6904, 5660, 1920],
            },
            {
                name: $_('todays_realisation'),
                type: 'line',
                yAxisIndex: 0,
                data: [2500, 4300, 6501, 6903, 7509, 9501],
                lineStyle: {
                    width: 6, // Increase the line width here
                },
                smooth: false, // Optional: makes the line smooth
            },
        ],
    };

    dashboardItem.we.setChartOption(defaultChartOption);
    dashboardItem.we.setDataSchema(DataSchema);
    dashboardItem.we.setUpdateFunction((defaultChartOption, data: DataType) => {
        return {
            ...defaultChartOption,
            xAxis: [
                {
                    ...defaultChartOption?.xAxis[0],
                    data: data.data_labels,
                },
            ],
            series: [
                {
                    ...defaultChartOption?.series[0],
                    data: data.data_history,
                },
                {
                    ...defaultChartOption?.series[1],
                    data: data.data_current,
                },
            ],
        };
    });
</script>

<WidgetTemplateInner bind:widgetManager {dashboardItem} />
